import { useS } from '../../store/game';
import { Panel, Sw, KV } from '../../components/ui';
import { RESS } from '../../content/ressorts';
import { PN } from '../../engine/rules';
import { oppPoll, playerByPid, statesOf } from '../../engine/versus';
import { de, sg } from '../../engine/util';

/** Rechte Spalte des Mitspielers: seine Partei statt der Parteiflügel des Hosts. */
export function PartyPanel({ pid }: { pid: string }) {
  const S = useS(); const M = playerByPid(pid);
  const mine = RESS.filter((r: any) => S.ress && S.ress[r.id] === pid);
  const laws = S.laws.filter((L) => L.by === pid);
  const st = statesOf(pid);
  const done = laws.filter((L) => ['kraft', 'done'].includes(L.stage)).length;
  return (
    <Panel title={<><Sw id={pid} />{PN(pid)}</>} aside={M?.role2 === 'partner' ? 'Koalitionspartner' : 'Opposition'}>
      <KV rows={[
        ['Umfrage', <b className="num">{de(oppPoll(pid))} %</b>],
        ['Rückenwind', <b className={'num ' + ((M?.bonus ?? 0) > 0 ? 'up' : (M?.bonus ?? 0) < 0 ? 'down' : '')}>{sg(M?.bonus ?? 0)} Pkt</b>],
        ['Sitze im Bundestag', <b className="num">{S.res.seats[pid] ?? 0}</b>],
        ['Landesregierungen', <b className="num">{st.n ? `${st.n} · ${st.v} Bundesratsstimmen` : 'keine'}</b>],
        ['Eigene Gesetze', <b className="num">{done} in Kraft, {laws.length - done} in Arbeit</b>],
      ]} />
      {mine.length > 0 && <div className="tags">{mine.map((r: any) => <span key={r.id} className="tag">{r.n}{S.min && S.min[r.id] ? ` · ${S.min[r.id].n}` : ''}</span>)}</div>}
    </Panel>
  );
}
